export default __webpack_public_path__ + "static/media/package1.30ac00f6.jpg";